import { render } from "./CardGame.vue?vue&type=template&id=33d85268"
import script from "./CardGame.vue?vue&type=script&lang=js"
export * from "./CardGame.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/CardGame.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33d85268"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33d85268', __exports__)) {
    api.reload('33d85268', __exports__)
  }
  
  module.hot.accept("./CardGame.vue?vue&type=template&id=33d85268", () => {
    api.rerender('33d85268', render)
  })

}


export default __exports__